module.exports = __webpack_public_path__ + "img/untitled - Copy.258048b7.png";